import { useUserData } from 'app/main/components';
import { ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabProps, ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import DocumentsFoldersListItem from '../DocumentsFoldersListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="documentsfoldersView" itemLayout={DocumentsFoldersListItem} />
	}
];

export default tabs;
